import PermPhoneMsgIcon from "@mui/icons-material/PermPhoneMsg";
import React from "react";

export const ContactNumber = () => {
	return (
		<a
			className="contact"
			href="https://wa.me/5492612526800"
			target="_blank"
			rel="noreferrer"
		>
			+54 9 2612526800{" "}
			<PermPhoneMsgIcon fontSize="small" className="contact-icon" />
		</a>
	);
};
